import httpClient from "constants/httpClient";
import { HEADWALL } from "constants/appConstant";

const getProducts = async () => {
  return await httpClient.get(HEADWALL.GET_PRODUCTS);
};

const getServices = async (product, category, manufacturer, sub_model) => {
  return await httpClient.get(
    `${HEADWALL.GET_SERVICES}?model=${product}&category=${category}&manufacturer=${manufacturer}&subModel=${sub_model}`
  );
};

const getTemplates = async (headwall) => {
  return await httpClient.get(`${HEADWALL.GET_TEMPLATES}/${headwall}`);
};

const getTemplateById = async (template_id) => {
  return await httpClient.get(`${HEADWALL.GET_TEMPLATE_BY_ID}/${template_id}`);
};

const getSpecifications = async (
  service_id,
  category_id,
  product,
  manufacturer_id
) => {
  return await httpClient.get(
    `${HEADWALL.GET_SPECIFICATIONS}?panel=${product}&category=${category_id}&service=${service_id}&manufacturer=${manufacturer_id}`
  );
};

const saveDesign = async (values) => {
  return await httpClient.post(HEADWALL.SAVE_DESIGN, values);
};

const downloadDesign = async () => {
  return await httpClient.get(HEADWALL.DOWNLOAD_DESIGN);
};

const editDesign = async (designId) => {
  return await httpClient.get(
    HEADWALL.EDIT_DESIGN.replace("{designId}", designId)
  );
};
const updateDesign = async ({ updatedValues, designId }) => {
  return await httpClient.patch(
    HEADWALL.UPDATE_DESIGN.replace("{designId}", designId),
    updatedValues
  );
};

const getCategories = async () => {
  return await httpClient.get(HEADWALL.GET_CATEGORIES);
};

const getManufacturers = async (category, panel) => {
  return await httpClient.get(
    `${HEADWALL.GET_MANUFACTURERS}?category=${category}&panel=${panel}`
  );
};

const getAccessories = async (mountType, category_id) => {
  return await httpClient.get(
    `${HEADWALL.GET_ACCESSORIES}?mount=${mountType}&category=${category_id}`
  );
};

const getAccessorieRails = async (model) => {
  return await httpClient.get(
    `${HEADWALL.GET_ACCESSORIE_RAILS}?model=${model}`
  );
};

const getAccessorieCategories = async () => {
  return await httpClient.get(HEADWALL.GET_ACCESSORIE_CATEGORY);
};
export {
  getProducts,
  getServices,
  saveDesign,
  getSpecifications,
  downloadDesign,
  editDesign,
  updateDesign,
  getTemplates,
  getTemplateById,
  getCategories,
  getManufacturers,
  getAccessories,
  getAccessorieRails,
  getAccessorieCategories,
};
